"use client";

import { useCallback } from "react";
import { useRouter } from "@/i18n/navigation";

/**
 * Back-navigation handler that respects the user's real history.
 *
 * The returned function navigates to the actual previous page via
 * `router.back()` — so a "back" control always returns the user to where they
 * came from, never a hardcoded page. When there is no in-app history to pop
 * (the page was opened directly: deep link, shared URL, fresh tab) it falls
 * back to `fallbackHref` so the control is never a dead no-op.
 *
 * @param fallbackHref destination when there is no history to return to (default "/")
 */
export const useGoBack = (fallbackHref = "/") => {
  const router = useRouter();

  return useCallback(() => {
    if (typeof window !== "undefined" && window.history.length > 1) {
      router.back();
      return;
    }
    router.push(fallbackHref);
  }, [router, fallbackHref]);
};
